import { html, svg } from 'lighterhtml';
import { useContext, useEffect, useCallback } from 'haunted/lib/core';

import { component } from '../../utils';
import menuIcon from '!raw-loader!./assets/menu-icon.svg';
import closeIcon from '!raw-loader!./assets/close-icon.svg';
import { AccordionContext } from '../accordion/accordion.context';

import './mobile-menu-button.css';

const useMenuIcon = [menuIcon];
const useCloseIcon = [closeIcon];

function MobileMenuButton(el: HTMLElement) {
  const context = useContext(AccordionContext);

  const onClick = useCallback(
    (e: Event) => {
      e.stopPropagation();

      context.handleItemClick('menu');
    },
    [context]
  );

  useEffect(() => {
    // Detect click outside to close
    if (el.dataset.icon !== 'close') {
      return;
    }

    const closeHandler = () => {
      context.closeItem('menu');
    };

    document.addEventListener('click', closeHandler);

    return () => {
      document.removeEventListener('click', closeHandler);
    };
  }, [context]);

  const icon = el.dataset.icon === 'close' ? useCloseIcon : useMenuIcon;

  // @ts-ignore
  return html`<div onclick=${onClick}>${svg(icon)}</div>`;
}

export const MobileMenuButtonElement = component(MobileMenuButton);
